import { useLocation } from 'react-router-dom';
import dayjs from 'dayjs';

// AI answers link to a page with ?date=YYYY-MM-DD or ?month=YYYY-MM so the page
// opens on the day/month the question was about instead of today.
export function useDeepLinkWhen() {
  const { search } = useLocation();
  const p = new URLSearchParams(search);
  const rawDate = p.get('date') || '';
  const rawMonth = p.get('month') || '';
  const date = /^\d{4}-\d{2}-\d{2}$/.test(rawDate) && dayjs(rawDate).isValid() ? dayjs(rawDate) : null;
  let month = null;
  if (/^\d{4}-\d{2}$/.test(rawMonth) && dayjs(rawMonth + '-01').isValid()) month = dayjs(rawMonth + '-01');
  else if (date) month = date;
  return { date, month };
}
